<template>
  <div
    :class="{ disabled: disableAutoRefresh }"
    class="rex-select"
    :tabindex="tabindex"
    @blur="open = false"
  >
    <div class="rex-ref-button">
      <div
        class="refreshIcon"
        @click="!disableAutoRefresh && $emit('reload')"
        id="btn-refresh"
      >
        <span class="icon">
          <BaseIcon width="2em" name="refresh"></BaseIcon>
        </span>
      </div>
      <div
        class="flexs"
        :id="id"
        @click="open = !open"
        v-if="!disableAutoRefreshTimer"
      >
        <div class="icon-down">
          <BaseIcon name="arrowDown" height="0.8em" width="0.8em" />
        </div>
      </div>
    </div>
    <div
      class="items"
      :class="{
        selectHide: !open || disableAutoRefresh || disableAutoRefreshTimer,
      }"
    >
      <div
        v-for="(option, i) of options"
        :key="i.key"
        @click="
          selected = option;
          open = false;
          $emit('input', option);
        "
        :class="selected.id === option.id ? 'selected-text' : 'item-text'"
        :id="`${option.id}`"
      >
        {{ option.label }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    /**
     * array of objects containing options for dropdown
     */
    options: {
      type: Array,
      required: true,
    },
    /**
     * Currently selected dropdown option
     */
    current: {
      type: Object,
    },
    /**
     * @ignore
     */
    tabindex: {
      type: Number,
      required: false,
      default: 0,
    },
    /**
     * id for the dropdown component
     */
    id: {
      type: String,
      required: true,
    },
    /**
     * Disable auto Refresh
     */
    disableAutoRefresh: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * Disable auto Refresh timer selection but the soft reload will be enabled
     */
    disableAutoRefreshTimer: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selected: this.current
        ? this.current
        : this.options.length > 0
          ? this.options[0]
          : '',
      open: false,
    };
  },
  mounted() {
    /**
     * emmitted when a dropdown option is selected
     * @property {Object}
     * @event input
     */
    this.$emit('input', this.selected);
  },
};
</script>

<style lang="scss" scoped>
.rex-ref-button {
  display: flex;
  overflow: hidden;
  height: 2.3em;
}
.rex-select {
  position: relative;
  outline: none !important;
  //width: 4.5em;
  height: 2.3em;
  border-radius: 0.3125rem;
  background-color: $color-brand-accent;
  //overflow: hidden;
}
.flexs {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  width: 1.9em;
  border-radius: 0 0.3125rem 0.3125rem 0;
}
.flexs1 {
  display: flex;
  flex-direction: row;
  width: 12.5em;
  height: 2.125em;
  background-color: $color-brand-accent;
  border-radius: 0.3125rem 0.3125rem 0rem 0rem;
  @include active-state;
}
.dropdown-title {
  text-align: left;
  // margin-top: 0.625rem;
  margin-left: 0.625em;
  margin-top: 0.375em;
  width: 6.25em;
  font-size: 1em;
  color: $font-contrast !important;
}
.icon-down {
  margin-top: 0.3125em;
  margin-left: 0.6em;
  cursor: pointer;
  svg {
    fill: $font-contrast !important;
  }
}
.dropdown-title-1 {
  text-align: left;
  margin-left: 0.625em;
  margin-top: 0.375em;
  width: 5%;
  font-size: 1em;
}

.selected-item {
  font-size: 1em;
  font-family: $semi-bold !important;
  color: $font-contrast;
  cursor: pointer;
  text-align: left;
  width: 6.25em;
  margin-top: 0.3125em;
  display: flex;
  background-color: $color-brand-accent;
}

.icon-down svg {
  fill: $font-contrast;
}

.flexs .open {
  border-bottom-right-radius: 1.875rem !important;
  border-bottom-left-radius: 1.875rem !important;
}

.rex-select .selected-item.open {
  border-radius: 0.5rem;
  .rex-select {
  }
  .flexs {
    border-bottom-right-radius: 0em !important;
    border-bottom-left-radius: 0em !important;
  }
}

.rex-select .selected-item:after {
  position: absolute;
  text-decoration: none;
  outline: none;
  .flexs {
    border-bottom-right-radius: 0rem !important;
    border-bottom-left-radius: 0rem !important;
  }
}

.rex-select .items {
  color: $font-primary;
  border-radius: 0rem 0rem 0.375rem 0.375rem;
  overflow: hidden;
  border-right: 0.0625rem solid $border-primary;
  border-left: 0.0625rem solid $border-primary;
  border-bottom: 0.0625rem solid $border-primary;
  width: 100%;
  position: absolute;
  background-color: $bg-secondary;
  outline: none;
  cursor: pointer;
  max-height: 15.625em;
  overflow-y: auto;
  z-index: 1;
  border: 0.0313rem solid $border-active;
}
.selected-text {
  //margin-right: 0.625em;
  // width: 1.6em;
  // text-decoration: none;
  display: flex;
  align-items: center;
  padding-left: 0.5em;
  font-size: 1em;
  background-color: $color-brand-accent;
  color: $font-contrast;
  text-decoration: none;
  outline: none !important;
  width: 4.5em;
  text-align: initial;
}
.item-text {
  display: flex;
  align-items: center;
  padding-left: 0.5em;
  font-size: 1em;
  text-decoration: none;
  outline: none;
  text-align: initial;
}
.rex-select .items div {
  color: $font-primary;
  height: 1.9375em;
  text-decoration: none;

  user-select: none;
}

.rex-select .items :hover {
  background-color: $color-brand-accent;
  color: $font-contrast;
  text-decoration: none;
  outline: none !important;
  width: 4.5em;
}

.selectHide {
  display: none;
  text-decoration: none;
  outline: none;
}

.refreshIcon {
  display: flex;
  padding: 4px;
  border-radius: 0.3125em;
  cursor: pointer;
}

.disabled {
  background-color: gray !important;
  opacity: inherit;
}
.icon {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
</style>
